const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.amazonaws.com/prod';

export const currencyAPI = {
  convertCurrency: async (fromCurrency, toCurrency, amount) => {
    try {
      const response = await fetch(`${API_BASE_URL}/currency`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          from_currency: fromCurrency,
          to_currency: toCurrency,
          amount: amount
        })
      });

      if (!response.ok) {
        throw new Error('Failed to convert currency');
      }

      return await response.json();
    } catch (error) {
      console.error('Currency API error:', error);
      // Return fallback conversion
      const fallbackRates = {
        USD: { INR: 83, GBP: 0.79, EUR: 0.92, USD: 1 },
        INR: { USD: 0.012, GBP: 0.0095, EUR: 0.011, INR: 1 },
        GBP: { USD: 1.27, INR: 105, EUR: 1.16, GBP: 1 },
        EUR: { USD: 1.09, INR: 90, GBP: 0.86, EUR: 1 }
      };
      const rate = fallbackRates[fromCurrency]?.[toCurrency] || 1;
      return { converted_amount: amount * rate, rate };
    }
  }
};